import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { NursingAuditService } from 'src/app/services/nursing-audit.service';
import { ResolutionCodingService } from 'src/app/services/resolution-coding.service';
import { ILogger, LOGGER_TOKEN } from 'src/app/services/logger/ilogger';

@Component({
    selector: 'app-follow-up-modal',
    templateUrl: './follow-up-modal.component.html',
    styleUrls: ['./follow-up-modal.component.css'],
    standalone: false
})
export class FollowUpModalComponent implements OnInit {
  private readonly logger = inject<ILogger>(LOGGER_TOKEN);
  private auditService = inject(NursingAuditService);
  private resolutionCodingService = inject(ResolutionCodingService);

  @Input() selectedRow: any;
  @Input() deId=false;
  comment!: string;
  comments: any;
  msgs!:[];
  followups:any;
  followUpVal!:string;

  @Output() completed = new EventEmitter<boolean>();
  getClass(priority: any){
    let classRisk='';

    if(priority == 'DDPT Review - Low Risk' || priority == 'DDPT Provided Education' || priority == 'Unit Provided Education'|| priority == 'Unit Mgn/DDPT Review - Low') {
       classRisk = 'risk-0';
    }else if (priority == 'Unit Mgn/DDPT Review - Med' || priority == 'Continue Surveillance'){
        classRisk = 'risk-2';
    }else if (priority == 'Unit Mgn/DDPT Review - High'){
        classRisk = 'risk-4';
    }else if (priority == 'DDPT Investigation' || priority == 'DDPT Terminated'){
        classRisk = 'risk-5';
    }
    return classRisk;
  }

  getResolutionBg(val: any)
  {
    return this.resolutionCodingService.getAuditFollowUptatusBg(val);
  }

  ngOnInit(): void {
    this.followups = this.resolutionCodingService.getAuditFollowUpStatusOptions();


  }

  formatDateCustom(dateStr: string): string {
    let output = '';
    const dateObj = new Date(dateStr); // creating new object from date string
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
    // takes jan as 0, so we have to update it by 1 
    output += month + '/';
    const date = (dateObj.getUTCDate()).toString().padStart(2, '0');
    output += date + '/';
    const fullYear = dateObj.getUTCFullYear();
    output += fullYear + ' | ';
    const hours = (dateObj.getUTCHours()).toString().padStart(2, '0');
    output += hours + ':';
    const minutes = (dateObj.getUTCMinutes()).toString().padStart(2, '0');
    output += minutes;
    return output;
  }

  async getData(rowData: any) {
    try {
      this.selectedRow = rowData;
      this.auditService.getFollowUps(rowData["_id"]).subscribe((res)=>{
        this.comments = (res as any)["docs"].reverse();

      });


    } catch (err) { 
      this.logger.exception(err);
      this.comments = [];
    }
  }

  async closeDialog(){
    this.completed.emit(true);
  }

  async submit() {
    try {
      await this.auditService
        .submitFollowUp(this.selectedRow["_id"], this.selectedRow.resolutionCoding)
        .toPromise();
      this.completed.emit(true);
    } catch {
      // Intentionally ignore here; API error is handled by the observable callback.
    }
  }
  
  isDeId(name: any){
    if(this.deId)
      return "xxxxxx xxxxxx"
    else
      return name
  }

}